import Typography from '@mui/material/Typography';

import pickupIcon from '@/assets/create-order/icon_pickup.svg';

const PickupTitle = () => {
  return (
    <Typography variant="subtitle2" component="div" className="flex">
      <img src={pickupIcon} alt="Icon" className="w-6 h-6 text-primary inline" />
      <span className="inline ml-2">
        ¿Dónde <span className="text-primary">recolectamos</span> tu{' '}
        <span className="text-primary">paquete</span>?
      </span>
    </Typography>
  );
};

export default PickupTitle;
